import { render, staticRenderFns } from "./layoutBlank.vue?vue&type=template&id=0b5b5807&"
import script from "./layoutBlank.vue?vue&type=script&lang=js&"
export * from "./layoutBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports